import React, { Fragment } from 'react';
import { Row, Col } from 'antd';
import ContainerBody from '@components/ContainerBody';
import Breadcrumb from '@components/Breadcrumb';
import { Add } from './components/Add';
import { useParams } from 'react-router-dom';

const AddCustomer = () => {
  const { id } = useParams();
  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath={'/dashboard'}
          routeSegments={[
            { name: 'Quản lý khách hàng', path: '/customers' },
            { name: id ? 'Cập nhật thông tin khách hàng' : 'Thêm mới khách hàng' }
          ]}
        />
      </div>
      <Row>
        <Col span={24}>
          <Add />
        </Col>
      </Row>
    </ContainerBody>
  );
};

export default AddCustomer;
